import { defineMessages } from 'react-intl';

import { SubscriptionActivationMode } from './types';

export const subscriptionActivationModeMessages =
  defineMessages<SubscriptionActivationMode>({
    immediately: {
      id: 'subscriptionForm.activationMode.immediately',
      defaultMessage: 'Activate immediately',
    },
    atDate: {
      id: 'subscriptionForm.activationMode.atDate',
      defaultMessage: 'Schedule for a date and time',
    },
    onLimitTrigger: {
      id: 'subscriptionForm.activationMode.onLimitTrigger',
      defaultMessage: 'Activate when the current subscription runs out',
    },
  });

export const addSubscriptionMessages = defineMessages({
  activationModeLabel: {
    id: 'subscriptionForm.activationMode.label',
    defaultMessage: 'Activation',
  },
  immediatelyDisabledHint: {
    id: 'subscriptionForm.activationMode.immediatelyDisabledHint',
    defaultMessage:
      'Unavailable while the account already has an active subscription.',
  },
  onLimitTriggerHint: {
    id: 'subscriptionForm.activationMode.onLimitTriggerHint',
    defaultMessage:
      'The current subscription is closed and this one is activated as soon as the selected limits are exhausted.',
  },
  onLimitTriggerDisabledHint: {
    id: 'subscriptionForm.activationMode.onLimitTriggerDisabledHint',
    defaultMessage:
      'Unavailable without an active subscription whose limits could run out.',
  },
  limitTriggerLabel: {
    id: 'subscriptionForm.limitTrigger.label',
    defaultMessage: 'Activation trigger',
  },
  limitTriggerPlaceholder: {
    id: 'subscriptionForm.limitTrigger.placeholder',
    defaultMessage: 'Select the limits that must be exhausted',
  },
  customPriceRenewalHint: {
    id: 'subscriptionForm.autoRenewal.customPriceHint',
    defaultMessage: 'Renewal will be invoiced at the list price {price}.',
  },
});
